import { ButtonColor } from '../../../ui/gzIconButton/types';

export interface StatusMessage {
  icon: string;
  firstText: string;
  secondText?: string;
  iconColor?: ButtonColor;
  iconSize?: string;
}

export enum RisksOverviewSectionEvents {
  CLICK_ON_CUSTOM_BUTTON = 'clickOnCustomButton',
}

export interface ButtonProps {
  buttonText: string;
  detailForEvent: number;
}

export interface RiskIncidentOverviewSectionData {
  title: string;
  data: RiskIncidentOverviewSectionRow[];
}

export interface ErrorInterface {
  errorCode: number;
}

export interface RiskIncidentOverviewSectionRow {
  entities: number[];
  type: number | null;
  name: string | null;
  status: number | null;
  severityScore: number | null;
}

export const ICON_RISK_MANAGEMENT = 'icon-menu_risk_management';
